(function (angular) {

    angular.module("app")
        .directive("validateEmailUniqueness", ["app.purchase.purchaseFlowService", "$http", "$q", func]); 
            function func(service, $http, $q) {
                // requires an isolated model
                return {
                    // restrict to an attribute type.
                    restrict: "A",
                    // element must have ng-model attribute.
                    require: "ngModel",
                    link: function (scope, ele, attrs, ctrl) {
                        ctrl.$asyncValidators.validateEmail = function (mValue, vValue) {
                            scope.emailSpinner = true;
                            return service.validateEmailAddress(vValue).then(function (response) {
                                ctrl.$setValidity("unique", response.data.wasUnique);
                                if (!response.data) {
                                    $q.reject();
                                } else {
                                    $q.resolve();
                                }
                                scope.emailSpinner = false;
                            }, function () {
                                $q.reject();
                                scope.emailSpinner = false;
                            });
                        }
                    }
                }
            }
})(angular);